import select from '@assets/audio/select_quizz.mp3';
import { Howl } from 'howler';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { getStatusGrid } from '~/pages/components/game/activities-forms/utils';
//import { classic } from '~/themes';

type IProps = {
  background?: string;
  selectedAnswers: string[];
  onChangeSelectedAnswers: (answers: string[]) => void;
  $submitted?: boolean;
  correctAnswers: string[];
};

type TProps = IProps;

export function ClickImageItem({
  background,
  selectedAnswers,
  onChangeSelectedAnswers,
  $submitted,
  correctAnswers,
}: TProps) {
  const [answers, setAnswers] = useState<string[]>([]);
  const [soundSelect, setSoundSelect] = useState<Howl | null>(null);
  const grid = [
    'a1',
    'b1',
    'c1',
    'd1',
    'a2',
    'b2',
    'c2',
    'd2',
    'a3',
    'b3',
    'c3',
    'd3',
    'a4',
    'b4',
    'c4',
    'd4',
  ];

  useEffect(() => {
    setAnswers(selectedAnswers);
  }, [selectedAnswers]);

  useEffect(() => {
    setSoundSelect(
      new Howl({
        src: [select],
        volume: 0.4,
        html5: true,
      })
    );

    return () => {
      soundSelect?.stop();
      soundSelect?.unload();
    };
  }, []);

  function handleItemClick(item: string) {
    soundSelect?.play();
    const _selectedAnswers = [...answers];
    const _item = item.toUpperCase();
    if (!_selectedAnswers.includes(_item)) {
      _selectedAnswers.push(_item);
    } else {
      const ind = _selectedAnswers.findIndex((el) => el === _item);
      if (ind !== -1) {
        _selectedAnswers.splice(ind, 1);
      }
    }
    setAnswers(_selectedAnswers);
    onChangeSelectedAnswers(_selectedAnswers);
  }

  return (
    <Container>
      <img src={background} alt="" />
      <SGrid>
        {grid.map((item, index) => (
          <SGridItem
            key={index}
            $selected={answers.includes(item.toUpperCase())}
            $submitted={$submitted}
            onClick={() => handleItemClick(item)}
            className={item}
            $status={getStatusGrid(item.toUpperCase(), answers, correctAnswers)}
          />
        ))}
      </SGrid>
    </Container>
  );
}
const Container = styled.div`
  position: relative;
  width: 100%;
  img {
    height: auto;
    width: 100%;
  }
`;

const SGridItem = styled.div<{
  $selected?: boolean;
  $submitted?: boolean;
  $status: 'good' | 'wrong' | 'warning' | 'neutral';
}>`
  background-color: ${({ $selected, $submitted, $status }) => {
    if (!$submitted) {
      return $selected ? '#08b5cc4D' : 'transparent';
    } else {
      if ($status === 'good') return '#14b15c80';
      if ($status === 'wrong') return '#dd484880';
      if ($status === 'warning') return '#f7b43880';
      $selected ? '#08b5cc4D' : 'transparent';
    }
  }};
  border: 1px solid white;
`;

const SGrid = styled.div`
  display: grid;
  left: 0;
  grid-template-columns: repeat(4, 1fr);

  grid-auto-rows: repeat(4, 1fr);
  top: 0;
  height: 100%;
  position: absolute;
  width: 100%;

  &.a1 {
    grid-column: 1;
    grid-row: 1;
  }
  &.a2 {
    grid-column: 1;
    grid-row: 2;
  }
  &.a3 {
    grid-column: 1;
    grid-row: 3;
  }
  &.a4 {
    grid-column: 1;
    grid-row: 4;
  }

  &.b1 {
    grid-column: 2;
    grid-row: 1;
  }
  &.b2 {
    grid-column: 2;
    grid-row: 2;
  }
  &.b3 {
    grid-column: 2;
    grid-row: 3;
  }
  &.b4 {
    grid-column: 2;
    grid-row: 4;
  }

  &.c1 {
    grid-column: 3;
    grid-row: 1;
  }
  &.c2 {
    grid-column: 3;
    grid-row: 2;
  }
  &.c3 {
    grid-column: 3;
    grid-row: 3;
  }
  &.c4 {
    grid-column: 3;
    grid-row: 4;
  }

  &.d1 {
    grid-column: 4;
    grid-row: 1;
  }
  &.d2 {
    grid-column: 4;
    grid-row: 2;
  }
  &.d3 {
    grid-column: 4;
    grid-row: 3;
  }
  &.d4 {
    grid-column: 4;
    grid-row: 4;
  }
`;
